var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFixupLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 25,
    viewBox: "0 0 92 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.81921H14.1998V7.64923H5.76286V11.7952H12.9975V16.6252H5.76286V24.6061H0V2.81921Z",
    fill: "#FAFBFE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1484 2.88143C16.1484 1.20232 17.4959 0 19.3615 0C21.2272 0 22.5746 1.20232 22.5746 2.88143C22.5746 4.56053 21.2272 5.76286 19.3615 5.76286C17.4959 5.76286 16.1484 4.56053 16.1484 2.88143ZM16.4801 7.83583H22.243V24.5854H16.4801V7.83583Z",
    fill: "#FAFBFE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6897 15.8789L23.9426 7.83582H30.0786L31.2809 10.1783C31.7162 11.1111 32.193 12.1269 32.6283 13.0597H32.7527C33.0636 12.1269 33.4575 11.1111 33.7477 10.1783L34.5562 7.83582H40.5263L35.7792 16.5423L40.7958 24.5854H34.6391L33.2917 22.243C32.7941 21.3101 32.3174 20.2944 31.8198 19.3615H31.6955C31.3223 20.2944 30.9285 21.2687 30.5553 22.243L29.6225 24.5854H23.6523L28.6897 15.8789Z",
    fill: "#FAFBFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5576 2.81921H48.3205V14.7388C48.3205 18.6152 49.3155 20.0249 51.5958 20.0249C53.876 20.0249 54.954 18.6152 54.954 14.7388V2.81921H60.5095V14.0754C60.5095 21.5174 57.6903 25 51.5958 25C45.5012 25 42.5576 21.5174 42.5576 14.0754V2.81921Z",
    fill: "#FEFEFE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1787 2.81921H72.6157C77.3006 2.81921 81.3222 4.56051 81.3222 10.0539C81.3222 15.3814 77.1762 17.6824 72.6157 17.6824H69.9416V24.5854H64.1787V2.81921ZM72.3669 13.1219C74.6472 13.1219 75.7252 11.9817 75.7252 10.0331C75.7252 8.08456 74.5228 7.35902 72.3669 7.35902H69.9623V13.1219H72.3669Z",
    fill: "#FEFEFE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3648 18.7604C83.437 18.2836 81.7578 19.1957 81.3433 20.9163C80.9287 22.6368 81.9859 24.2123 83.9137 24.6891C85.8416 25.1659 87.5207 24.2537 87.9353 22.5332C88.3706 20.7919 87.2927 19.2372 85.3648 18.7604Z",
    fill: "#FAFBFE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8673 7.46268L85.2404 5.05804C85.655 3.33747 87.3963 2.28026 89.1169 2.69485L89.49 2.77777C91.2106 3.19236 92.2678 4.93366 91.8532 6.65422L91.0447 9.05887L87.5414 17.2886L84.0381 16.4386L84.8673 7.46268Z",
    fill: "#FEFEFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFixupLogoWhite);
export default __webpack_public_path__ + "static/media/FIXUP-LOGO-WHITE.5e42362b784d9555112ad6492a0c60e6.svg";
export { ForwardRef as ReactComponent };